// @ts-nocheck
import { TrackLinkParameters } from "@store/Framework/GoogleAnalytics/trackers/trackLink";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";

const useTrackLink = (parameters: TrackLinkParameters = {}, options?: Toolkit.GoogleAnalytics.Options) =>
    ga.util.getEventTrackerHook(ga.track.trackLink, parameters, options);

export default useTrackLink;
